import React from "react";
import { TableHead as MuiTableHead, TableRow, TableCell as MuiTableCell, TableSortLabel, styled } from "@mui/material";

import { TableCell } from "./Table";

const StyledTableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: "inherit!important",
  paddingLeft: 0,
  whiteSpace: "nowrap",
  paddingTop: theme.spacing(0),
  paddingBottom: theme.spacing(0),
  padding: "12px 0px 12px 16px !important", // pretty nasty, right?
  "&.MuiTableCell-sizeSmall": {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    paddingRight: theme.spacing(2),
  },
}));

export interface TableHeadProps {
  cells: TableCell[];
  onOrder: (key: string) => void;
}

const TableHead: React.FC<TableHeadProps> = ({ cells, onOrder }) => {
  const cellToInt = (cell: TableCell) => {
    switch (cell.size) {
      case "small":
        return 1;
      case "large":
        return 3;
      case "xlarge":
        return 5;
      default:
        return 2;
    }
  };
  const total = cells.reduce((accumulator, cell) => accumulator + cellToInt(cell), 0);

  return (
    <MuiTableHead>
      <TableRow>
        {cells.map(cell => (
          <StyledTableCell key={cell.id} width={`${cellToInt(cell) * (100 / total)}%`}>
            {cell.sortable ? (
              <TableSortLabel
                active={cell.active}
                direction={cell.desc ? "asc" : "desc"}
                onClick={() => {
                  onOrder(cell.id);
                }}
              >
                {cell.label}
              </TableSortLabel>
            ) : (
              cell.label
            )}
          </StyledTableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  );
};

export default TableHead;
